"use client";

import { SafeHydrate } from "@/SafeHydrate";
import * as React from "react";
import { PawPrint } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Card, CardContent } from "@/components/ui/card";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
const testimonials = [{
  author: "Elena M.",
  quote: "My daughter loves her Spanish adventure! She's already singing songs and asking for more games. It's the highlight of her week!",
  position: "Parent of Sofia (Age 5)",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1614297/img/jane_s_avatar.png"
}, {
  author: "Ricardo G.",
  quote: "The teachers are so joyful. My son was shy at first, but now he's confidently speaking Spanish at the dinner table!",
  position: "Parent of Lucas (Age 7)",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1614297/img/mark_t_avatar.png"
}];
export default function HappyTailsTales() {
  return <section data-section-id="73762" id="happy-learner-stories" className="dark bg-background text-foreground py-16 md:py-24 bg-gradient-to-b from-background via-accent/5 to-secondary/10">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-12 text-center">
          <h2 className="font-serif text-3xl font-bold tracking-tight text-foreground md:text-5xl lg:text-7xl drop-shadow-sm">
            Happy Learner Stories
          </h2>
          <p className="mt-4 text-xl text-muted-foreground font-sans">
            Hear from the families discovering the joy of Spanish every single day.
          </p>
        </div>

        <div className="mx-auto max-w-5xl">
          <Carousel opts={{
          align: "start",
          loop: true
        }} className="w-full">
            <CarouselContent className="-ml-4 md:-ml-6">
              {testimonials.map((testimonial, i) => <CarouselItem key={i} data-index={i} className="pl-4 md:basis-1/2 md:pl-6 lg:basis-1/2">
                  <Card className="h-full border-4 border-secondary/20 bg-card shadow-2xl transition-all hover:scale-[1.02] hover:border-primary/30 rounded-[3rem] rounded-bl-none">
                    <CardContent className="flex h-full flex-col justify-between gap-6 p-6 md:p-10">
                      <div>
                        <div className="mb-6 flex gap-1">
                          {[...Array(5)].map((_, starIndex) => <PawPrint key={starIndex} data-index={starIndex} className="size-6 fill-primary text-primary drop-shadow-md" />)}
                        </div>
                        <p className="font-sans text-lg font-medium leading-relaxed text-foreground md:text-2xl">
                          "{testimonial.quote}"
                        </p>
                      </div>

                      <div className="mt-6 flex items-center gap-4">
                        <SafeHydrate><Avatar className="size-16 border-4 border-secondary/40 shadow-lg">
                          <AvatarImage src={testimonial.avatar} alt={testimonial.author} />
                          <AvatarFallback className="bg-secondary/20 font-bold text-secondary">
                            {testimonial.author.charAt(0)}
                          </AvatarFallback>
                        </Avatar></SafeHydrate>
                        <div>
                          <p className="font-serif text-xl text-foreground">
                            {testimonial.author}
                          </p>
                          <p className="text-sm font-medium text-muted-foreground">
                            {testimonial.position}
                          </p>
                        </div>
                      </div>
                    </CardContent>
                  </Card>
                </CarouselItem>)}
            </CarouselContent>
            <div className="hidden md:block">
              <CarouselPrevious className="-left-12 border-4 border-secondary/30 bg-card shadow-xl transition-all hover:bg-primary hover:text-primary-foreground hover:scale-110" />
              <CarouselNext className="-right-12 border-4 border-secondary/30 bg-card shadow-xl transition-all hover:bg-primary hover:text-primary-foreground hover:scale-110" />
            </div>
          </Carousel>
        </div>
      </div>
    </section>;
}